/**
 * Handles initializing google map geo location, setting markers for each studio, and auto centering on each studio if
 * hovered.
 *
 * @return api
 */
SC.geo_locate = (function () {
  var api = {};

  api.initializeMap = function () {
    var MY_MAPTYPE_ID = 'soul_style';
    var featureOpts = [
      {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#BABABA'
          },
          {
            'lightness': 17
          }
        ]
      },
      {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f5f5'
          },
          {
            'lightness': 20
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 17
          }
        ]
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 29
          },
          {
            'weight': 0.2
          }
        ]
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 18
          }
        ]
      },
      {
        'featureType': 'road.local',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#ffffff'
          },
          {
            'lightness': 16
          }
        ]
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f5f5f5'
          },
          {
            'lightness': 21
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dedede'
          },
          {
            'lightness': 21
          }
        ]
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'color': '#ffffff'
          },
          {
            'lightness': 16
          }
        ]
      },
      {
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'saturation': 36
          },
          {
            'color': '#333333'
          },
          {
            'lightness': 40
          }
        ]
      },
      {
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'transit',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#f2f2f2'
          },
          {
            'lightness': 19
          }
        ]
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#fefefe'
          },
          {
            'lightness': 20
          }
        ]
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#fefefe'
          },
          {
            'lightness': 17
          },
          {
            'weight': 1.2
          }
        ]
      }
    ];

    var mapOptions = {
      zoom: 12,
      center: new google.maps.LatLng(40.790278, -73.959722),
      disableDefaultUI: true,
      mapTypeId: MY_MAPTYPE_ID,
      scrollwheel: false,
      zoomControl: true,
      draggable: true,
      minZoom: 3,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.LEFT_BOTTOM
      }
    };

    if ($(window).width() < 480) {
      mapOptions.zoomControl = false;
    } else if (($(window).width() === 1024 || $(window).width() === 768) && $.browser.device === 'ipad') {
      mapOptions.zoomControl = false;
      mapOptions.scaleControl = false;
    }

    map = new google.maps.Map(document.getElementById('studios-map-canvas'), mapOptions);

    var allowedBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(-80, -180),           // bottom left corner of map
      new google.maps.LatLng(80, 180)            // top right corner
    );

    var lastValidCenter = map.getCenter();

    google.maps.event.addListener(map, 'center_changed', function () {
      if (allowedBounds.contains(map.getCenter())) {
        // still within valid bounds, so save the last valid position
        lastValidCenter = map.getCenter();
        return;
      }
      // not valid anymore => return to last valid position
      map.panTo(lastValidCenter);
    });

    var styledMapOptions = {
      name: 'Soul Style'
    };

    var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);

    map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

    var infowindow = new google.maps.InfoWindow({
      maxWidth: 200
    });

    var marker;
    var markers = [];

    // Mouse out marker to close info
    $(function () {
      enquire.register('screen and (max-width : 1440px)', function () {
        if (map.getZoom() < 3) {
          map.setZoom(3);
        }
        map.setOptions({minZoom: 3});
      }).register('screen and (min-width : 1441px)', function () {
        if (map.getZoom() < 4) {
          map.setZoom(4);
        }
        map.setOptions({minZoom: 4});
      });
    });

    // Add the markers and infowindows to the map
    $('.map-marker').each(function (index) {
      var $this = $(this);
      var mapInfoWindowData = $this.find('.map-info-window').data();
      var lat = parseFloat(mapInfoWindowData.lat);
      var lon = parseFloat(mapInfoWindowData.lon);
      var studio = $this.html();
      var studioType = mapInfoWindowData.studioType;
      var fileType = '.svg';

      if (!Modernizr.objectfit) {
        fileType = '.ico';
      }

      marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lon),
        map: map,
        icon: '/assets/images/marker-' + studioType + fileType
      });

      markers.push(marker);

      // Mouse over marker to get info
      google.maps.event.addListener(marker, 'mouseover', (function (marker) {
        return function () {
          infowindow.setContent(studio);
          infowindow.open(map, marker);
        };
      })(marker, index));

      google.maps.event.addListener(marker, 'mouseout', (function () {
        return function () {
          if ($.browser.isTouchCapable) {
            infowindow.close();
          }
        };
      })(marker, index));

      // Click map and close info
      google.maps.event.addListener(map, 'click', (function () {
        return function () {
          infowindow.close();
        };
      })());
    });

    // First remove the event handlers for the old map links since we may be re-initializing the map.
    // Then add the event handlers to all the new map links.
    $(document).off('click', '.newrider-experience__view-studio-link');
    $(document).on('click', '.newrider-experience__view-studio-link', function () {
      /**
       * mParticle sendEvent - Click Studio Page - Location: New Rider, Context: Map
       * Sends an mParticle event and label for Google Analytics event.
       */
      var $viewStudioLink = $(this);
      var location = 'New Rider';
      var eventData = {
        'Studio Name': $viewStudioLink.data('studio-title'),
        'Context': $viewStudioLink.data('context'),
        'Location': location
      };
      SC.analytics.mp.sendEvent('Click Studio Page', 'navigation', eventData, location);
    });

    function autoCenter() {
      //  Create a new viewpoint bound
      var bounds = new google.maps.LatLngBounds();
      //  Go through each...
      $.each(markers, function (index, marker) {
        bounds.extend(marker.position);
      });


      if (markers.length > 1) {
        //  Fit these bounds to the map
        map.fitBounds(bounds);
      } else {
        // Make sure not to zoom in too far initially
        map.setCenter(bounds.getCenter());
        map.setZoom(12);
      }
    }

    autoCenter();
  };

  return api;
})();
